import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1tbqbry65c: FaireBrandEntity = {
  token: "b_1tbqbry65c",
  type: "brand",
  name: "Rad Hat Society",
  avatarUrl:
    "https://cdn.faire.com/fastly/9c7150c3aab0838f4ac6c6f74756ae3098321fb43c2482387dd9914baf8bd34a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a296b2d7a9bfd43732da4e4e6d537187fb2af3912db9eb4064c84f65aacc587d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9c7150c3aab0838f4ac6c6f74756ae3098321fb43c2482387dd9914baf8bd34a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a296b2d7a9bfd43732da4e4e6d537187fb2af3912db9eb4064c84f65aacc587d.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 54,
  isTopShop: true,
  isInsider: true,
  description:
    "Rad Stuff Society was born from one woman's love of clever design, nostalgia, and creating everyday products that make people smile. Founded by Erin Campbell in Los Angeles, every collection begins in her studio and is produced in small batches with an emphasis on quality, personality, and lasting style.\n\nWhat started with handmade trucker hats has grown into a colorful collection of lifestyle goods, including fiberglass catchall trays, accessories, and gifts. Inspired by movie quotes, 80s and 90s nostalgia, hometown pride, vintage graphics, playful illustrations, and witty sayings, every piece is designed to spark conversation and bring a little more joy to everyday life.\n\nRather than chasing trends, Rad Stuff Society focuses on timeless humor, bold color, and thoughtful design. Whether it's a favorite city, a quirky food obsession, or a pop culture reference, each collection blends nostalgia with a fresh, modern perspective.\n\nEverything is created using premium materials and a small-batch approach that values craftsmanship over mass production. The result is a collection that's giftable, easy to merchandise, and full of personality.\n\nFrom a hat you'll wear every weekend to a tray that brightens your home, every piece is designed to make everyday life a little more rad.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:46.989Z",
    importedBy: "entity-db-cli",
  },
};
